/**
 * @flow
 * @format
 */

import globalActions from './global';

export const app = globalActions;

export default {
  ...globalActions,
};



// WEBPACK FOOTER //
// ./src/routines/index.js